export const environment = {
  production: false,
  hmr: false,
  apiUrl: 'https://api.ecollect.sidc.coop',
  reportApiUrl: 'https://api.reports.sidc.coop',
  apiVersion: '1'
};